import React, { useState } from "react";
import "./ForgotPassword.scss";
import { requestForgotPass } from "services/user/userService";
import { PacmanLoader } from "react-spinners";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async () => {
    // Kiểm tra nếu email không rỗng và hợp lệ
    if (email && /\S+@\S+\.\S+/.test(email)) {
      try {
        setIsLoading(true);
        const response = await requestForgotPass(email);
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Gửi yêu cầu thành công!",
            text: "Mời bạn kiểm tra email để lấy lại mật khẩu!",
            timer: 5000,
            timerProgressBar: true,
            showConfirmButton: false,
            customClass: {
              popup: "my-swal", // Liên kết với lớp CSS
            },
          }).then(() => {
            // navigate("/login");
          });
        }
      } catch (error) {
        if (error.status === 404) {
          Swal.fire({
            icon: "error",
            // title: "Gửi yêu cầu thành công!",
            text: "Không tìm thấy tài khoản của bạn tại VoviBookstore!",
            timer: 5000,
            customClass: {
              popup: "my-swal", // Liên kết với lớp CSS
            },
          });
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      alert("Vui lòng nhập địa chỉ email hợp lệ.");
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-box">
        <h2 className="a">Quên Mật Khẩu</h2>
        <h6 className="a">
          Nhập email của bạn để lấy lại tài khoản
        </h6>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Nhập email"
          value={email}
          onChange={handleEmailChange}
          required
        />
        <button onClick={handleSubmit}>Lấy lại mật khẩu</button>
      </div>

      {isLoading && (
        <div className="modal">
          <div className="overlay_loading">
            <div className="modal-content_loading">
              <div className="d-flex">
                <PacmanLoader color="#5e2e86" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
